export const themeColors = {
  primary: '#4B3082',
  primaryDark: '#2F1E57',
  primaryLight: '#5C35D8',
  primaryGradient: 'linear-gradient(135deg, #2F1E57 0%, #4B3082 100%)',

  //   const PURPLE = '#5C35D8'
  // const SIDEBAR_HOVER = '#4B3082'
  // const BRAND_PURPLE = '#2F1E57',



  sidebar: '#16325c',
  sidebarHover: '#243f6b',
  sidebarActive: '#4B3082',
  sidebarBorder: '#1a3a6b',

  topbar: '#ffffff',
  topbarBorder: '#e0e5ee',

  background: '#f3f2f2',
  surface: '#ffffff',
  surfaceHover: '#f8f9fc',

  text: {
    primary: '#181818',
    secondary: '#706e6b',
    inverse: '#ffffff',
    link: '#4B3082',
    muted: '#aeaeae',
  },

  status: {
    new: '#4bca81',
    working: '#4B3082',
    escalated: '#c23934',
    resolved: '#4bca81',
    closed: '#706e6b',
    converted: '#4bca81',
    nurturing: '#ff9a3c',
    contactado: '#4B3082',
  },

  priority: {
    low: '#4bca81',
    medium: '#ff9a3c',
    high: '#c23934',
    media: '#ff9a3c',
  },

  border: '#e0e5ee',
  borderLight: '#f0f0f0',
  divider: '#e8e8e8',

  success: '#4bca81',
  successLight: '#eaf8f0',
  warning: '#ff9a3c',
  warningLight: '#fff3e0',
  error: '#c23934',
  errorLight: '#fdecea',
  info: '#4B3082',
  infoLight: '#e8f4fd',

  shadow: {
    sm: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
    md: '0 4px 12px rgba(0,0,0,0.10), 0 2px 4px rgba(0,0,0,0.06)',
    lg: '0 8px 24px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.06)',
    dialog: '0 20px 60px rgba(0,0,0,0.18)',
  },

  gradient: {
    blue: 'linear-gradient(135deg, #2F1E57 0%, #4B3082 100%)',
    green: 'linear-gradient(135deg, #4bca81 0%, #3abf74 100%)',
    orange: 'linear-gradient(135deg, #ff9a3c 0%, #f7882a 100%)',
    red: 'linear-gradient(135deg, #c23934 0%, #d94f3d 100%)',
    navy: 'linear-gradient(180deg, #16325c 0%, #1e3f73 100%)',
  },
}
